export default __webpack_public_path__ + "images/M5.982f03f.png";